import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p><span className="subtitle-table">Pacing and leading</span></p>
                                            <p>Once you have paced and matched the state of someone’s demeanour
                                                you’re in a position to move them gently from one state of mind
                                                to another with your own body language, gestures and tone of
                                                voice. For example, by mirroring the movements of an angry and
                                                upset person you acknowledge that their feelings are important.
                                                It’s then possible to lead them to a ‘calmer’ state by
                                                moderating the tone of your voice and relaxing your posture.<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>5</sup></a></p>
                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span
                                                    className="heading">PACING WORDS, PHRASES AND IMAGES</span>
                                            </div>
                                            <div className="BottomPadding"><p>When you’re talking to other
                                                people, pay attention to the kind of language they use. Is there
                                                a pattern? Do they use words from the descriptions below? Once
                                                you’ve picked up on a theme it’s easy to ‘pace’ the kind of
                                                words, phrases and images used.</p></div>
                                            <div className="desktop ipad-portrait-show">
                                                <table className="ilead_v_sport" border="0" cellPadding="0"
                                                       cellSpacing="0" width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve" align="left" valign="center"
                                                            width="20%">Language Style
                                                        </th>
                                                        <th align="left" valign="top" width="40%">What they may
                                                            say
                                                        </th>
                                                        <th className=" green_curve1" align="left" valign="top"
                                                            width="40%"> Try
                                                        </th>

                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="10%"><p className="visual">Visual</p>
                                                        </td>

                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="40%"><p>
                                                        </p>
                                                            <ul className="greenbullet-list ">

                                                                <li>‘I can see what you mean by that’</li>
                                                                <li>‘I need to be able to picture how this
                                                                    works’
                                                                </li>
                                                                <li>Lets draw a diagram of how these aspects fit
                                                                    together’
                                                                </li>
                                                                <li>‘To see clearly’ or ‘To illuminate’</li>
                                                                <li>‘To imagine’ or ‘To focus’</li>
                                                                <li>‘Unclear’ or ‘Visualise’</li>
                                                                <li>‘Coloured’ or ‘To demonstrate’</li>
                                                            </ul>
                                                            <p></p>
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="50%">
                                                            <p>
                                                            </p>
                                                            <ul className="greenbullet-list ">

                                                                <li>Presenting your ideas using pictures and
                                                                    diagrams.
                                                                </li>
                                                                <li>Sitting back and describing your plan or
                                                                    elements of it like a picture or model.
                                                                </li>
                                                                <li>Physically demonstrating how something works
                                                                    rather than describing how it works.
                                                                </li>

                                                            </ul>
                                                            <p></p>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="10%"><p className="Acoustic">Acoustic</p>
                                                        </td>

                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="40%"><p>
                                                        </p>
                                                            <ul className="greenbullet-list">

                                                                <li>‘Lets talk through that idea so that we can
                                                                    hear how it sounds’
                                                                </li>
                                                                <li>‘To listen’ or ‘To hear’</li>
                                                                <li>‘To shout’</li>
                                                                <li>‘To speak’</li>
                                                                <li>‘To call’</li>
                                                                <li>‘To discuss’ or ‘To chat about’</li>
                                                            </ul>
                                                            <p></p>
                                                        </td>
                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="50%">
                                                            <p>
                                                            </p>
                                                            <ul className="greenbullet-list">

                                                                <li>Presenting information orally and allowing
                                                                    time for discussion.
                                                                </li>
                                                                <li>Describing how something works rather than
                                                                    physically demonstrating.
                                                                </li>

                                                            </ul>
                                                            <p></p>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="10%"><p
                                                            className="Kinesthetic">Kinesthetic</p>
                                                        </td>

                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="40%"><p>
                                                        </p>
                                                            <ul className="greenbullet-list">

                                                                <li>‘I feel like this is going to work’</li>
                                                                <li>‘This seems real to me’</li>
                                                                <li>‘To touch’</li>
                                                                <li>‘To feel’</li>
                                                                <li>‘I feel relaxed about this’</li>
                                                                <li>‘This makes me really tense’</li>
                                                                <li>‘I’m feeling the pressure’</li>
                                                            </ul>
                                                            <p></p>
                                                        </td>
                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="50%">
                                                            <p>
                                                            </p>
                                                            <ul className="greenbullet-list">

                                                                <li>Describing how things feel to you rather
                                                                    than what you think about them.
                                                                </li>
                                                                <li>Allowing the other person to try things out
                                                                    before deciding whether they work or not.
                                                                </li>


                                                            </ul>
                                                            <p></p>
                                                        </td>

                                                    </tr>

                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="mobile ipad-portrait-hide">
                                                <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                       className="ilead_v_sport tablesrink para-bottompad">


                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve" width="50%">Language Style
                                                        </th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Visual</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">What they may say</td>
                                                        <td valign="top">
                                                            <ul className="greenbullet-list ">

                                                                <li>‘I can see what you mean by that’</li>
                                                                <li>‘I need to be able to picture how this
                                                                    works’
                                                                </li>
                                                                <li>Lets draw a diagram of how these aspects fit
                                                                    together’
                                                                </li>
                                                                <li>‘To see clearly’ or ‘To illuminate’</li>
                                                                <li>‘To imagine’ or ‘To focus’</li>
                                                                <li>‘Unclear’ or ‘Visualise’</li>
                                                                <li>‘Coloured’ or ‘To demonstrate’</li>
                                                            </ul>
                                                        </td>


                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius">Try
                                                        </td>
                                                        <td valign="top" id="m-border-light">
                                                            <ul className="greenbullet-list ">

                                                                <li>Presenting your ideas using pictures and
                                                                    diagrams.
                                                                </li>
                                                                <li>Sitting back and describing your plan or
                                                                    elements of it like a picture or model.
                                                                </li>
                                                                <li>Physically demonstrating how something works
                                                                    rather than describing how it works.
                                                                </li>

                                                            </ul>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th className="green_curve" width="50%">Language Style
                                                        </th>
                                                        <td className=" green_curve1">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Acoustic </strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">What they may say</td>
                                                        <td valign="top" className="darkgreen">
                                                            <ul className="greenbullet-list">
                                                                <li> Resolves conflicts in the team</li>
                                                                <li> Will help others to please or impress</li>
                                                                <li> Responds to recognition or
                                                                    acknowledgement
                                                                </li>
                                                                <li className="list-bottom-pad">Takes others’
                                                                    comments very much to heart
                                                                </li>

                                                            </ul>
                                                            <p>Take the time to recognise/reward achievements
                                                                and good work.</p>

                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius">Try
                                                        </td>
                                                        <td valign="top" id="m-border-right">

                                                            <ul className="greenbullet-list">

                                                                <li>Describing how things feel to you rather
                                                                    than what you think about them.
                                                                </li>
                                                                <li>Allowing the other person to try things out
                                                                    before deciding whether they work or not.
                                                                </li>


                                                            </ul>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th className="green_curve" width="50%">Language Style
                                                        </th>
                                                        <td className=" green_curve2">
                                                            <div className="paddingcenter6"><span
                                                                className="subtitle-table"><strong>Kinesthetic</strong></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg">What they may say</td>
                                                        <td valign="top">
                                                            <ul className="greenbullet-list">

                                                                <li>‘I feel like this is going to work’</li>
                                                                <li>‘This seems real to me’</li>
                                                                <li>‘To touch’</li>
                                                                <li>‘To feel’</li>
                                                                <li>‘I feel relaxed about this’</li>
                                                                <li>‘This makes me really tense’</li>
                                                                <li>‘I’m feeling the pressure’</li>
                                                            </ul>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td className="m-orange-bg" id="m-border-radius">Try
                                                        </td>
                                                        <td valign="top" id="m-border-light">

                                                            <ul className="greenbullet-list">

                                                                <li>Describing how things feel to you rather
                                                                    than what you think about them.
                                                                </li>
                                                                <li>Allowing the other person to try things out
                                                                    before deciding whether they work or not.
                                                                </li>


                                                            </ul>
                                                        </td>

                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}